import authGuard from '@/router/auth-guard'

export default [
  {
    path: '/payOutstandingBalance',
    name: 'payOutstandingBalance',
    component: () =>
      import(
        /* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/payment/PayOutstandingBalance.vue'
      ),
    beforeEnter: authGuard
  },
  {
    path: '/billingtabs',
    name: 'billingtabs',
    component: () => import(/* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/Main.vue'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'accountActivity',
        name: 'billing.accountActivity',
        component: () =>
          import(
            /* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/tabs/accountActivity/List.vue'
          )
      },
      {
        path: 'statementsOfAccount',
        name: 'billing.statementsOfAccount',
        component: () =>
          import(
            /* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/tabs/statementsOfAccount/List.vue'
          )
      },
      {
        path: 'ownerPaymentMethods',
        name: 'billing.ownerPaymentMethods',
        component: () =>
          import(
            /* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/tabs/ownerPaymentMethodList/List.vue'
          )
      },
      {
        path: 'scheduledPayments',
        name: 'billing.scheduledPayments',
        component: () =>
          import(
            /* webpackChunkName: "billing" */ '@/pages/Homeowner/billing/tabs/scheduledPayments/index.vue'
          )
      },
      {
        // If no tab is specifed, go to overview
        path: '',
        redirect: 'accountActivity'
      },
      {
        // If path doesn't match, go to overview
        path: '*',
        redirect: 'accountActivity'
      }
    ]
  }
]
